enum FlowPlaceholderTemplate {
    BASIC = "basic",
    IMAGE = "image",
    LIST = "list",
    GALLERY = "gallery",
    FORM = "form",
    ERROR = "error",
    LOADING = "loading"
}

export default FlowPlaceholderTemplate;
